export function getUrlVars(url) {
    var vars = {};
    url.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
        return m;
    });
    return vars;
}
export function addTimeout(timeout, callback, request) {
    return window.setTimeout(function () {
        callback(new Error("Request timed out after ".concat(timeout.toString(), " milliseconds. Request: ").concat(JSON.stringify(request))));
    }, timeout);
}
// returns undefined if the feature key is not set on the window
// otherwise, returns the feature key value converted to a bool
export function getFeatureStatus(flipperName) {
    var _a, _b, _c;
    var feature = (_c = (_b = (_a = window.Qualtrics) === null || _a === void 0 ? void 0 : _a.Environment) === null || _b === void 0 ? void 0 : _b.features) === null || _c === void 0 ? void 0 : _c[flipperName];
    if (feature === undefined)
        return undefined;
    return !!feature;
}
//# sourceMappingURL=utils.js.map